/*
 * Qual ambiente esta aba está operando.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ DERIVADO DO HOSTNAME, E NÃO DE VARIÁVEL DE AMBIENTE.                     │
 * │                                                                          │
 * │ O selo é obrigatório e impossível de ignorar (doc 06a §4.1): operador    │
 * │ cancelando boleto no ambiente errado é incidente de dinheiro real.       │
 * │                                                                          │
 * │ Uma variável injetada no build é uma coisa a mais para pôr errada — e a  │
 * │ forma de errá-la é a pior possível: uma imagem de produção construída    │
 * │ com o valor de homologação mostraria a faixa âmbar de "pode testar" numa │
 * │ tela que cancela boleto de verdade, e nada no sistema perceberia.        │
 * │                                                                          │
 * │ O hostname é a mesma coisa que o operador vê na barra de endereço. Não   │
 * │ há build que o contradiga.                                               │
 * └──────────────────────────────────────────────────────────────────────────┘
 */
export type Ambiente = "producao" | "homologacao" | "local";

const HOSTS: Record<string, Ambiente> = {
  "painel.boletos-maker.gestaomaker.com.br": "producao",
  "dev.boletos-maker.gestaomaker.com.br": "homologacao",
  localhost: "local",
  "127.0.0.1": "local",
};

/**
 * Hostname desconhecido é tratado como PRODUÇÃO.
 *
 * O padrão é o mais restritivo de propósito. Errar para "homologação" faria a
 * tela dizer que é seguro experimentar num lugar em que talvez não seja; errar
 * para "produção" só faz aparecer uma tarja vermelha onde não precisava, e
 * alguém corrige o mapa. Só um dos dois erros custa dinheiro.
 */
export function ambienteDe(hostname: string): Ambiente {
  return HOSTS[hostname] ?? "producao";
}

export function ambienteAtual(): Ambiente {
  return ambienteDe(window.location.hostname);
}

export const ROTULO: Record<Ambiente, string> = {
  producao: "Produção",
  homologacao: "Homologação",
  local: "Local",
};
